import {ACTION_TYPE} from "utils/constants";

export const editRoom = name => ({
  type: ACTION_TYPE.EDIT_ROOM,
  payload: name,
});

export const addChatList = message => ({
  type: ACTION_TYPE.ADD_CHAT_LIST,
  payload: message,
});

export const editChatMode = bool => ({
  type: ACTION_TYPE.EDIT_CHAT_MODE,
  payload: bool,
});

export const setChatAlert = bool => ({
  type: ACTION_TYPE.SET_CHAT_ALERT,
  payload: bool,
});
